import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/rewardCenter/detail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/rewardCenter/detail'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/rewardCenter/list/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/rewardCenter/list'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/rewardCenter/subtasks/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/rewardCenter/subtasks',
    meta: {
      title: '闪送'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/rewardCenter/ensureIncome/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/rewardCenter/ensureIncome',
    meta: {
      title: '奖励活动'
    }
  }
]
